import aspireLogo from '../assets/aspire-logo.jpg';

export const LOYALTY_PROGRAMS = [
  {
    id: 1,
    logo: aspireLogo,
  },
];
